import React from 'react';
import withLayout from '../../components/layout';
import AuctionList from '../../components/feature/auction-list/index';
import { useSelector } from 'react-redux';
import NewDealerScreen from '../../components/feature/new-dealer';

const ExploreAuction = () => {
    const { user: {
        status = ''
    } = {} } = useSelector(state => state) || {};

    const showRequestCallback = ['ENLISTED', 'BANNED'].includes(status);
    const showAuctions = ['ADDITIONAL_DETAILS_ADDED', 'ONBOARDED'].includes(status);

    return (
        <>
            {showAuctions && <AuctionList />}
            {showRequestCallback && <NewDealerScreen />}
        </>
    );
};

export default withLayout(ExploreAuction, true, true);
